import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css';
import AppContainer from './components/AppContainer/AppContainer.js';
import NotFound from './components/NotFound/NotFound';
import { useDispatch, useSelector } from 'react-redux';
import { setShowError } from './actions/actionCreators';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core';
import { APP_TYPE, SCHEDULER, ZENPAY } from './constants/AppConstants';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiCircularProgress-colorPrimary": props => ({
      color: props.color,
    }),
    // backgroundColor: 'khaki'
  },
}));

function App() {
  const loading = useSelector(state => state.navigationReducer.loading);
  const showError = useSelector(state => state.navigationReducer.showError);
  const errorText = useSelector(state => state.navigationReducer.errorText);
  const dispatch = useDispatch();
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const classes = useStyles({ color: frontConfig.color });

  // Scheduler
  const navigation = useSelector(state => state.navigationReducer);
  return (
    <Router>
      <Switch>
        {
          APP_TYPE === ZENPAY ?
            <Route path="/:token">
              <AppContainer />
              {
                loading ?
                  renderLoader() : null
              }
              {
                showError ?
                  renderErrorMessage() : null
              }
            </Route>
            :
            <Route path="/">
              <AppContainer />
              {
                loading || navigation.confirmSchedule ?
                  renderLoader() : null
              }
            </Route>
        }
        <Route component={NotFound} />
      </Switch>
    </Router>
  );

  function renderLoader() {
    return (
      <div className="LoaderContainer">
        <CircularProgress className={classes.root} />
      </div>
    )
  }

  function renderErrorMessage() {
    return (
      <div className="ErrorContainer fadeInOutAnim" onAnimationEnd={removeErrorMessage}>
        <p className="ErrorText">{errorText}</p>
      </div>
    )
  }

  function removeErrorMessage() {
    dispatch(setShowError({ showError: false }))
  }
}

export default App;
